import { createAction } from '@reduxjs/toolkit';
import { addFolder as addFolderAction } from 'reactApp/modules/tree/actions/addFolder.action';
import { loadTree as loadTreeAction } from 'reactApp/modules/tree/actions/load.action';

const setTreeAction = createAction<{ tree: any; }>('setTree');

export { loadTreeAction, addFolderAction, setTreeAction };
